import { StarFill, StarHalf } from '@styled-icons/bootstrap'
import ava1 from '../../assets/images/recommends/ava1.jpeg'
import ava2 from '../../assets/images/recommends/ava2.png'
import ava3 from '../../assets/images/recommends/ava3.png'

function RecommendSection() {
	return (
		<section className='mt-[50px] sm:mt-[70px]' id='recommendations'>
			<div className='flex flex-col items-center'>
				<p className='text-center text-black dark:text-white font-medium text-[20px] sm:text-[26px] xl:text-[32px]'>
					Рекомендации
				</p>
				<p className='mt-[15px] text-dark-100 sm:mt-[25px] text-center w-[300px] sm:w-[360px]'>
					В этом блоке предоставлены отзывы реальных покупателей и тех
					с кеми я работал.
				</p>
			</div>
			<div className='mt-[25px] max-w-full w-full'>
				<div className='flex items-center gap-[15px] overflow-x-scroll lg:grig grid-cols-3'>
					<div className='min-w-[255px] bg-white dark:bg-dark-300 pt-[37px] pb-[18px] pl-[25px] pr-[16px]'>
						<div className='flex items-center gap-[10px]'>
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
						</div>
						<p className='mt-[12px] text-black dark:text-white text-[18px] font-medium'>
							Высокий уровень!
						</p>
						<p className='mt-[20px] line-clamp-3 text-dark-100 text-[15px] h-[75px]'>
							Все сделал качественно и быстро, все правки
							выполнил, я доволен!
						</p>
						<div className='mt-[30px] flex items-center gap-[10px]'>
							<img
								src={ava1}
								alt='asdasdsa'
								className='w-[50x] h-[50px] xl:w-[80] xl:h-[80px] rounded-full'
							/>
							<div className='flex flex-col'>
								<p className='text-black dark:text-white font-medium'>
									Владимир Вацик
								</p>
								<p className='text-dark-100'>Парфюмер</p>
							</div>
						</div>
					</div>
					<div className='min-w-[255px] bg-white dark:bg-dark-300 pt-[37px] pb-[18px] pl-[25px] pr-[16px]'>
						<div className='flex items-center gap-[10px]'>
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarHalf className='fill-yellow-100 w-[18px] h-[18px]' />
						</div>
						<p className='mt-[12px] text-black dark:text-white text-[18px] font-medium'>
							Хорошее качество.
						</p>
						<p className='mt-[20px] line-clamp-3 text-dark-100 text-[15px] h-[75px]'>
							Дизайн прекрасный, сайт быстрый, вывел в топ 1 по
							нашей категории.
						</p>
						<div className='mt-[30px] flex items-center gap-[10px]'>
							<img
								src={ava2}
								alt='asdasdsa'
								className='w-[50x] h-[50px] xl:w-[80] xl:h-[80px] rounded-full'
							/>
							<div className='flex flex-col'>
								<p className='text-black dark:text-white font-medium'>
									Ирина Старцева
								</p>
								<p className='text-dark-100'>Цветочница</p>
							</div>
						</div>
					</div>
					<div className='min-w-[255px] bg-white dark:bg-dark-300 pt-[37px] pb-[18px] pl-[25px] pr-[16px]'>
						<div className='flex items-center gap-[10px]'>
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
							<StarFill className='fill-yellow-100 w-[18px] h-[18px]' />
						</div>
						<p className='mt-[12px] text-black dark:text-white text-[18px] font-medium'>
							Шикарная работа.
						</p>
						<p className='mt-[20px] line-clamp-3 text-dark-100 text-[15px] h-[75px]'>
							Сделал сайт за очень короткий срок, планирую брать
							приложение.
						</p>
						<div className='mt-[30px] flex items-center gap-[10px]'>
							<img
								src={ava3}
								alt='asdasdsa'
								className='w-[50x] h-[50px] xl:w-[80] xl:h-[80px] rounded-full'
							/>
							<div className='flex flex-col'>
								<p className='text-black dark:text-white font-medium'>
									Асхаб Лосев
								</p>
								<p className='text-dark-100'>Администратор</p>
							</div>
						</div>
					</div>
				</div>
				<div className='mt-[25px] flex items-center justify-center gap-[10px]'>
					<span className='w-[10px] h-[10px] bg-yellow-100 rounded-full'></span>
					<span className='w-[10px] h-[10px] bg-yellow-100 rounded-full'></span>
					<span className='w-[10px] h-[10px] bg-yellow-100 rounded-full'></span>
				</div>
			</div>
		</section>
	)
}

export default RecommendSection
